import m from "../../geodata/es2015/hungaryLow";
window.am4geodata_hungaryLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/hungaryLow.js
// module id = null
// module chunks = 